import { Fill, Stroke, Style, Text } from 'ol/style';
import { baseStyle, checkVisibility } from '@vendor/libs/maps/styles/base';
export const associationBoundariesHighlightedStyle = (text, resolution = 50) => {
    const style = associationBoundariesRegularStyle(text, resolution);
    style.setFill(new Fill({
        color: 'rgba(162,5,0,0.02)',
    }));
    style.setStroke(new Stroke({
        color: 'rgba(162,5,0,0.65)',
        width: 5,
    }));
    return style;
};
export const associationBoundariesRegularStyle = (text, resolution = 50) => {
    return new Style({
        stroke: new Stroke({
            color: '#a20500',
            width: 2,
        }),
        fill: new Fill({
            color: 'transparent',
        }),
        text: new Text({
            backgroundFill: new Fill({ color: 'rgba(162,5,0,0.3)' }),
            stroke: new Stroke({ color: 'black', width: 0.65 }),
            fill: new Fill({ color: 'white' }),
            scale: (1 / Math.pow(resolution, 1 / 5)) * 3,
            text,
        }),
    });
};
export default (feature, resolution) => {
    let visibilityName = 'association-boundaries-regular';
    if (feature.get('is_current') || feature.get('highlighted')) {
        visibilityName = 'association-boundaries-highlighted';
    }
    if (!checkVisibility(feature, visibilityName)) {
        return new Style({});
    }
    return baseStyle(feature, resolution, () => {
        if (feature.get('is_current') || feature.get('highlighted')) {
            return associationBoundariesHighlightedStyle(feature.get('label'), resolution);
        }
        return associationBoundariesRegularStyle(feature.get('label'), resolution);
    });
};
